import React from 'react';

const Header = ({ currentUser, stores, goldRates, latestGoldRate, onLogout, onMenuToggle }) => {
  const activeStore = stores.find(s => s.code === currentUser.store) || { name: "Head Office" };
  const rate24K = latestGoldRate?.rate24K ?? goldRates[goldRates.length - 1]?.r24 ?? 0;

  return (
    <header className="bg-white border-b-4 border-jewel-red shadow-md px-4 md:px-6 py-2 flex justify-between items-center sticky top-0 z-30">
      {/* Left Section - Menu Button & Logo */}
      <div className="flex items-center gap-2 md:gap-4 flex-1 min-w-0">
        {/* Mobile Menu Toggle */}
        <button 
          onClick={onMenuToggle}
          className="lg:hidden p-2 hover:bg-gray-100 rounded text-jewel-red"
          aria-label="Toggle menu"
        >
          <i className="fas fa-bars text-xl"></i>
        </button>
        
        {/* Logo */}
        <img src="/logo.png" alt="OMG Gold & Diamond" className="h-10 md:h-12 object-contain" />
      </div>
      
      {/* Center Section - Gold Rate (Hidden on small mobile) */}
      <div className="hidden sm:flex flex-1 justify-center">
        <div className="bg-red-50 border border-red-200 rounded-full px-3 md:px-4 py-1 inline-block">
          <span className="font-semibold text-gray-700 text-xs md:text-sm">Gold Rate (24K): </span>
          <span className="font-bold text-jewel-red text-xs md:text-sm">
            ₹{rate24K ? Number(rate24K).toLocaleString('en-IN') : '—'}
          </span>
        </div>
      </div>
      
      {/* Right Section - User Name & Logout */}
      <div className="flex items-center justify-end gap-2 md:gap-4 flex-1">
        <span className="font-medium italic text-gray-600 text-xs md:text-sm hidden md:inline truncate max-w-[150px]">
          {currentUser.name}
        </span>
        <button 
          onClick={onLogout}
          className="text-xs bg-gray-200 px-2 md:px-3 py-1 md:py-1.5 rounded hover:bg-gray-300 transition whitespace-nowrap"
        >
          <i className="fas fa-sign-out-alt md:mr-1"></i>
          <span className="hidden md:inline">Logout</span>
        </button>
      </div>
    </header>
  );
};

export default Header;
